import React, { useContext } from "react"
import { getAuth } from "firebase/auth"
import { useNavigate } from "react-router-dom"

import { UserContext } from "../context/userContext"

import logoDefault from "../images/logo_starset_analytics.png"
import logoMMA from "../images/MMA-Primary-Logo-H-RGB-White.webp"
import logoHFMA from "../images/logo_hfma_white.png"

import styles from "../styles/NavMain.module.css"

// Menus
import * as Menu from "./menus/"

export default function MainNav({ toogle, setToogle }) {
  const navigate = useNavigate()
  const userCtx = useContext(UserContext)

  const handleMenuPerRole = () => {
    const role = Number(userCtx.user_role)
    switch (true) {
      case role === 0:
        return <Menu.SysAdmin />
      case role === 1:
        return <Menu.Admin />
      case role > 9:
        return <Menu.Analyst />
      default:
        return null
    }
  }

  const handleLogo = () => {
    const organization = userCtx.organization_alias
    switch (organization) {
      case "mma":
        return (
          <img
            src={logoMMA}
            alt="Marsh & McLennan Agency"
            className={styles.logoMma}
          />
        )
      case "hfma":
        return (
          <img
            src={logoHFMA}
            alt="Healthcare Financial Management Association"
            className={styles.logo}
          />
        )
      case "ths":
      case "ths_sandbox":
        return (
          <img
            src={logoDefault}
            alt="Starset Analytics"
            className={styles.logo}
          />
        )
      default:
        return (
          <img
            src={logoDefault}
            alt="Starset Analytics"
            className={styles.logo}
          />
        )
    }
  }

  return (
    <nav className={`nav-main ${styles.nav}`}>
      <div className={styles.secondaryMenu}>
        <ul>
          <li>
            <button
              className={styles.collapseToggle}
              onClick={() => setToogle(!toogle)}
              title={toogle ? "Collapse menu" : "Expand menu"}
            >
              <span className="material-icons">
                {toogle ? "chevron_left" : "chevron_right"}
              </span>
            </button>
          </li>
          <li>
            <span className="material-icons">account_circle</span>
            {toogle && <span className="label">Profile</span>}
          </li>
          <li>
            <button
              onClick={async () => {
                await getAuth().signOut()
                navigate("/")
              }}
            >
              <span className="material-icons">logout</span>
              {toogle && "Logout"}
            </button>
          </li>
        </ul>
      </div>
      <div className={styles.mainMenu}>
        {toogle && (
          <>
            {handleLogo()}
            {handleMenuPerRole()}
          </>
        )}
      </div>
    </nav>
  )
}
